<script>
  import { domainName, record } from '../stores.js';
</script>

<div class="record-box record-logo">
  <div id="headingRaw" class="box-label">
    <h5>BIMI Logo Found: <span>{$domainName}</span></h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseLogo" aria-expanded="true" aria-controls="collapseLogo" aria-label="Close"></button>
  </div>
  <div id="collapseLogo" class="image-box collapse show" aria-labelledby="headingRaw">
    <div class="color-box d-flex align-items-center">
      <img referrerpolicy="no-referrer" src="{$record.logo}" alt="{$domainName} logo">
    </div>
  </div>
</div>

<style>
  .image-box {
    padding: 1rem 0 ;
  }
  .color-box {
    border-radius: 50%;
    margin: 30px auto;
    padding: 54px 20px 54px 20px;
    height: 210px;
    width: 210px;
  }
  .color-box img {
    max-width: 170px;
    max-height: 100%;
    margin: 0 auto;
  }
</style>
